import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, DialogProps, Typography } from '@mui/material';
import React, { memo } from 'react';

import styles from './styles.module.scss';

interface Props extends Omit<DialogProps, 'onClose'> {
  title: string;
  description: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const Component: React.FC<Props> = ({
  title,
  description,
  loading,
  onCancel,
  onConfirm,
  ...dialogProps
}) => {
  return (
    <Dialog onClose={onCancel} {...dialogProps}>
      <div className={styles.modal}>
        <button aria-label="close" className={styles.modal__close} type="button" onClick={onCancel}>
          <CloseIcon sx={{ width: '18px', height: '18px', color: 'var(--gray-2-color)' }} />
        </button>
        <Typography color="text.primary" lineHeight="24px" mb="35px" variant="h5">
          {title}
        </Typography>
        <Typography color="var(--text-3-color)" lineHeight="24px" mb="36px" variant="subtitle1">
          {description}
        </Typography>
        <div className={styles.modal__buttons}>
          <Button color="secondary" disabled={loading} sx={{ width: '160px' }} onClick={onCancel}>
            Cancel
          </Button>
          <Button loading={loading} sx={{ width: '160px' }} onClick={onConfirm}>
            Yes
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export const ConfirmModal = memo(Component);
